import {
  getString,
  getOptionalString,
} from "@surya-digital/leo-ts-types";


export namespace ChatQuestionState {
  export interface ActiveDTO {
    case: string;
    draftAnswerJson?: string | null;
  }
  
  export class Active {
    readonly isChatQuestionStateActive: boolean = true;
  
    readonly draftAnswerJson: string | null;
  
  
    constructor(
    draftAnswerJson: string | null = null
    ) {
      if ( draftAnswerJson !== undefined && draftAnswerJson !== null) {
        Active.validateDraftAnswerJson(draftAnswerJson);
      }
      this.draftAnswerJson = draftAnswerJson;
    }
  
    static fromDTO(dto: ActiveDTO): Active {
      const draftAnswerJson = getOptionalString(dto, "draftAnswerJson", InvalidChatQuestionStateActiveDraftAnswerJsonError);
      return new Active(
        draftAnswerJson
      );
    }
  
    toDTO(): ActiveDTO {
      const dto: ActiveDTO = {
        case: "ACTIVE",
      };
      if (this.draftAnswerJson !== undefined && this.draftAnswerJson !== null){
        dto.draftAnswerJson = this.draftAnswerJson;
      }
      return dto;
    }
    private static validateDraftAnswerJson = (draftAnswerJson: string): void => {
      if(draftAnswerJson.trim().length === 0) {
        throw new InvalidChatQuestionStateActiveDraftAnswerJsonNonEmptyError(
          `Attribute draftAnswerJson cannot be an empty string.`
        );
      }
    }
    
  }
  
  Active.prototype.toString = function toString(): string {
    return `ChatQuestionState.ACTIVE(draftAnswerJson='${this.draftAnswerJson}')`;
  };
  
  export interface CompletedDTO {
    case: string;
    answerJson: string;
  }
  
  export class Completed {
    readonly isChatQuestionStateCompleted: boolean = true;
  
    readonly answerJson: string;
  
  
    constructor(
    answerJson: string
    ) {
      Completed.validateAnswerJson(answerJson);
      this.answerJson = answerJson;
    }
  
    static fromDTO(dto: CompletedDTO): Completed {
      const answerJson = getString(dto, "answerJson", InvalidChatQuestionStateCompletedAnswerJsonError);
      return new Completed(
        answerJson
      );
    }
  
    toDTO(): CompletedDTO {
      const dto: CompletedDTO = {
        case: "COMPLETED",
          answerJson: this.answerJson
      };
      return dto;
    }
    private static validateAnswerJson = (answerJson: string): void => {
      if(answerJson.trim().length === 0) {
        throw new InvalidChatQuestionStateCompletedAnswerJsonNonEmptyError(
          `Attribute answerJson cannot be an empty string.`
        );
      }
    }
    
  }
  
  Completed.prototype.toString = function toString(): string {
    return `ChatQuestionState.COMPLETED(answerJson='${this.answerJson}')`;
  };
  

  export type ChatQuestionState = Active | Completed;

  export type ChatQuestionStateDTO = ActiveDTO | CompletedDTO;

  export const fromDTO = (dto: ChatQuestionStateDTO): ChatQuestionState => {
    switch (dto.case) {
      case "ACTIVE":
          return Active.fromDTO(dto as ActiveDTO);
      case "COMPLETED":
          return Completed.fromDTO(dto as CompletedDTO);
      default:
        throw new InvalidChatQuestionStateError(
            `Case ${dto.case} is not valid case of ChatQuestionState.`
        );
    }
  };
}

export class InvalidChatQuestionStateError extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidChatQuestionStateError";
  }
}
export class InvalidChatQuestionStateActiveError extends InvalidChatQuestionStateError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidChatQuestionStateActiveError";
  }
}

export class InvalidChatQuestionStateActiveDraftAnswerJsonError extends InvalidChatQuestionStateActiveError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidChatQuestionStateActiveDraftAnswerJsonError";
  }
}

export class InvalidChatQuestionStateActiveDraftAnswerJsonNonEmptyError extends InvalidChatQuestionStateActiveDraftAnswerJsonError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidChatQuestionStateActiveDraftAnswerJsonNonEmptyError";
  }
}

export class InvalidChatQuestionStateCompletedError extends InvalidChatQuestionStateError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidChatQuestionStateCompletedError";
  }
}

export class InvalidChatQuestionStateCompletedAnswerJsonError extends InvalidChatQuestionStateCompletedError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidChatQuestionStateCompletedAnswerJsonError";
  }
}

export class InvalidChatQuestionStateCompletedAnswerJsonNonEmptyError extends InvalidChatQuestionStateCompletedAnswerJsonError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidChatQuestionStateCompletedAnswerJsonNonEmptyError";
  }
}
